import { FloatingArrow, FloatingPortal } from '@floating-ui/react'

import { EMPTY_OBJECT } from '../../../constants/common'
import { HTML_ELEMENT_THEME_PROVIDER_ID } from '../../../constants/html'

import * as styles from './FloatingTooltipContent.module.css'

function FloatingTooltipContent({
  arrowRef,
  className = styles.tooltip,
  content,
  contentStyles = EMPTY_OBJECT,
  context,
  floatingStyles,
  isOpen,
  markup,
  refs,
}) {
  return isOpen ? (
    <FloatingPortal id={HTML_ELEMENT_THEME_PROVIDER_ID}>
      <span
        className={className}
        // refs.setFloating is floating-ui's stable callback ref setter, not a ref-value read
        // eslint-disable-next-line react-hooks/refs
        ref={refs.setFloating}
        style={{ ...contentStyles, ...floatingStyles }}
      >
        {markup ? (
          <span
            className={styles.tooltipText}
            dangerouslySetInnerHTML={{ __html: content }}
          ></span>
        ) : (
          <span className={styles.tooltipText}>{content}</span>
        )}
        <FloatingArrow
          context={context}
          fill='var(--color-bg-tooltip)'
          height={6}
          ref={arrowRef}
          tipRadius={2}
          width={12}
        />
      </span>
    </FloatingPortal>
  ) : null
}

export default FloatingTooltipContent
